(function() {
  'use strict';

  angular
    .module('traineeWebApp.dashboard')
    .directive('mfDashboard', dashboard);

  dashboard.$inject = ['$window', '$timeout', 'MobileHelper'];

  function dashboard($window, $timeout, MobileHelper) {
    var directive = {
      link: link
    };

    return directive;

    function link(scope, element, attrs) {
      var body = $('body');
      var win = angular.element($window);

      scope.$on('scrollCModuleList', function(event, id) {
        setTimeout(function() {
          var elem = $('.list-group-item.active');
          var list = $('.cmodule-list-container');
          var scroll;
          if (elem && elem.length && list) {
            scroll = list[0].clientHeight - elem[0].clientHeight + elem[0].offsetTop;
            if (scroll > 0) {
              list.scrollTop(scroll);
            }
          }
        }, 300);
      });

      if (MobileHelper.isTouch()) {
        win.on('touchend', function(e) {
          if (e.target.id === 'clear-search' || e.target.id === 'clear-search-icon') {
            $timeout(function() {
              scope.viewState.searchCriteria = null;
            });
          }
        });
      }

      win.on('resize', onResize);

      function onResize() {
        $timeout(function() {
          // Force a digest so all of our elements get updated classes regarding whether or not to show three line
          // cModule status view.

          // If we're switching from tablet to phone view for a cModule within a course set it up so they can go
          // back to the list of course cModules.
          if (!scope.hasEnoughWidthForListAndDetailView() &&
            scope.selectedCModule &&
            scope.traineeCModuleList.indexOf(scope.selectedCModule) === -1 &&
            !scope.viewingCourseCModuleList &&
            scope.selectedCourse) {
            scope.viewingCModuleInCourse = true;
            _.each(scope.traineeCModuleList, function(cModule) {
              _.each(cModule.courseCModules, function(courseCModule) {
                if (courseCModule.id === scope.selectedCModule.id) {
                  scope.selectedCourse = cModule;
                }
              });
            });
          }

          // If we're switching to list and detail view make sure that we're not in any weird course viewing modes.
          if (!scope.viewState.isLoading && scope.hasEnoughWidthForListAndDetailView()) {
            scope.viewingCModuleInCourse = false;
            scope.viewingCourseCModuleList = false;
            scope.filterByState(scope.currentState);
          }

          // If we're switching to list and detail view and we don't currently have a selected cModule then
          // select the first one so the user doesn't have a weird view before they click on a cModule to select one.
          if (!scope.selectedCModule && scope.hasEnoughWidthForListAndDetailView() &&
            scope.traineeCModuleList && scope.traineeCModuleList.length > 0) {
            scope.selectedCModule = scope.traineeCModuleList[0];
          }
        });
      }

      scope.triggerResize = function() {
        win.trigger('resize');
      };

      scope.scrollCModuleDetailsToTop = function() {
        var cModuleDetailsContainer = $('#cmodule-details-container');
        if (cModuleDetailsContainer && cModuleDetailsContainer.length > 0 && cModuleDetailsContainer[0]) {
          cModuleDetailsContainer[0].scrollTop = 0;
        }
      };

      // TODO: Get rid of this function (sad panda)
      scope.hasEnoughWidthForListAndDetailView = function() {
        return body.width() >= 768;
      };

      scope.$on('$destroy', function() {
        win.off('resize', onResize);
      });
    }
  }
})();
